module.exports = __webpack_public_path__ + "03_face.98b9d60e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer1/03_face.png
// module id = scLL
// module chunks = 0